import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import careBalanceService from "../../services/careBalanceService";
import useCareBalance from "./hooks/useCareBalance";
import Modal from "../boxes/Modal";
import SingleTransaction from './SingleCareHistory';

const caretDown = "/img/care-balance/caret-down.svg";

const inputStyle = {
  flex: 1,
  fontSize: "1.4rem",
  border: "1px solid #cccccc",
  padding: "4px",
  borderRadius: "4px",
};



function FilterModal({
  onClose,
  t,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  filter,
}) {
  const [from, setFrom] = useState(
    dateFrom || format(new Date(filter?.dateFrom), "yyyy-MM-dd")
  );
  const [to, setTo] = useState(
    dateTo || format(new Date(filter?.dateTo), "yyyy-MM-dd")
  );

  return (
    <Modal
      onClose={onClose}
      style={{
        fontWeight: 700,
        color: "#212121",
        fontSize: "2.4rem",
        alignSelf: "flex-start",
      }}
      modalContentStyle={{
        minHeight: "unset",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          maxWidth: "560px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "16px",
            maxWidth: "560px",
          }}
        >
          <fieldset>
            <label htmlFor="dateFrom">
              <p style={{ fontSize: "1.4rem" }}>
                {t("careHistoryDateFromLabel")}
              </p>
            </label>
            <input
              id="dateFrom"
              type="date"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              style={{
                ...inputStyle,
              }}
            />
          </fieldset>

          <fieldset>
            <label htmlFor="dateTo">
              <p style={{ fontSize: "1.4rem" }}>
                {" "}
                {t("careHistoryDateToLabel")}
              </p>
            </label>
            <input
              id="dateTo"
              type="date"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              style={{
                ...inputStyle,
              }}
            />
          </fieldset>
        </div>

        <button
          style={{
            ...inputStyle,
            color: "#ffffff",
            backgroundColor: "#094063",
          }}
          onClick={() => {
            setDateFrom(from);
            setDateTo(to);
            onClose();
          }}
        >
          Apply
        </button>
      </div>
    </Modal>
  );
}

export default function CareHistoryTable({
  setCount,
  limit,
  offset,
  hmoId,
  showFilter = false,
  showViewAll = false,
  onViewAll = () => {},
  hideIfNoTransactions = false,
}) {
  const { t } = useTranslation("careBalance");

  const { wallet, loading: isFetchingCareBalance } = useCareBalance({
    hmoId,
  });

  const [filter, setFilter] = useState({});

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState();
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [transactions, setTransactions] = useState([]);

  const [fetchingTransactionHistory, setFetchingTransactionHistory] =
    useState(false);

  const loading = isFetchingCareBalance || fetchingTransactionHistory;

  useEffect(() => {
    if (!wallet?.id) {
      return;
    }

    setFetchingTransactionHistory(true);

    careBalanceService
      .getTransactions({
        walletId: wallet.id,
        filter: { limit, offset, dateFrom, dateTo },
      })
      .then(({ data = [], pagination = {}, filter }) => {
        if (setCount) {
          setCount(pagination?.count);
        }

        setTransactions(data);
        setFilter(filter);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setFetchingTransactionHistory(false);
      });
  }, [wallet?.id, limit, offset, dateFrom, dateTo]);

  if (!wallet?.id) {
    return <></>;
  }

  if (!transactions?.length && hideIfNoTransactions) {
    return <></>;
  }

  return (
    <>
      <div
        style={{
          padding: "20px",
          borderRadius: "4px",
          gap: "16px",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#ffffff",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2
            style={{
              color: "#212121",
              fontWeight: 900,
              fontSize: "1.659rem",
              lineHeight: "27px",
              letterSpacing: "0%",
            }}
            data-testid="care-history-page-title" 
          >
            {t("careHistoryPageTitle")}
          </h2>

          {showFilter && (
            <button
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "8px",
              }}
              onClick={() => {
                if (loading) {
                  return;
                }

                setShowFilterModal(true);
              }}
            >
              <p
                style={{
                  color: "#4F4F4F",
                  fontSize: "1.4rem",
                  lineHeight: "22px",
                  letterSpacing: "0%",
                }}
              >
                Filter
              </p>
              <img src={caretDown} alt="Caret Down" />
            </button>
          )}
        </div>

        {!!transactions?.length && (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            {transactions.map((transaction) => (
              <SingleTransaction
                key={transaction?.transactionRef}
                transaction={transaction}
              />
            ))}
          </div>
        )}

        {showViewAll && !!transactions?.length && (
          <button
            style={{
              border: "1px solid #094063",
              borderRadius: "4px",
              padding: "11.5px",
              fontWeight: 900,
              fontSize: "1.5rem",
              color: "#094063",
              alignSelf: "center",
            }}
            onClick={() => onViewAll()}
          >
            View All
          </button>
        )}
      </div>

      {showFilterModal && (
        <FilterModal
          t={t}
          onClose={() => {
            setShowFilterModal(false);
          }}
          dateFrom={dateFrom}
          dateTo={dateTo}
          setDateFrom={setDateFrom}
          setDateTo={setDateTo}
          filter={filter}
        />
      )}
    </>
  );
}
